import { render, staticRenderFns } from "./PhoneTable.vue?vue&type=template&id=295287d0&scoped=true"
import script from "./PhoneTable.vue?vue&type=script&lang=js"
export * from "./PhoneTable.vue?vue&type=script&lang=js"
import style0 from "./PhoneTable.vue?vue&type=style&index=0&id=295287d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295287d0",
  null
  
)

export default component.exports